/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
export var /** @type {?} */ UPGRADE_MODULE_NAME = '$$UpgradeModule';
export var /** @type {?} */ INJECTOR_KEY = '$$angularInjector';
export var /** @type {?} */ $INJECTOR = '$injector';
export var /** @type {?} */ $PARSE = '$parse';
export var /** @type {?} */ $ROOT_SCOPE = '$rootScope';
export var /** @type {?} */ $SCOPE = '$scope';
export var /** @type {?} */ $PROVIDE = '$provide';
export var /** @type {?} */ $DELEGATE = '$delegate';
export var /** @type {?} */ $$TESTABILITY = '$$testability';
export var /** @type {?} */ $COMPILE = '$compile';
export var /** @type {?} */ $TEMPLATE_CACHE = '$templateCache';
export var /** @type {?} */ $HTTP_BACKEND = '$httpBackend';
export var /** @type {?} */ $CONTROLLER = '$controller';
//# sourceMappingURL=constants.js.map


// WEBPACK FOOTER //
// ./~/@angular/upgrade/src/aot/constants.js